import { useQuery } from '@tanstack/react-query'
import {
  MultipleChoiceGroup,
  TemplatesApi,
} from '@ulysses-inc/harami_api_client'
import { baseClient } from 'src/state/middleware/saga/baseClient'
import { handleHTTPError } from 'src/state/middleware/saga/handleHttpError'
import { responseMultipleChoicesQueryKeys } from './queryKeys'

/**
 * 従来の選択肢（他のひな形でも使用中）を取得する
 */
export const useQueryMultipleChoices = () => {
  return useQuery({
    queryKey: responseMultipleChoicesQueryKeys.all,
    queryFn: async (): Promise<MultipleChoiceGroup[]> => {
      return await baseClient
        .getApi(TemplatesApi)
        .getResponseMultipleChoices()
        .catch(handleHTTPError)
    },
  })
}
